
<div class="tab-container">
    <form nz-form [formGroup]="form" nzLabelAlign="right" nzLayout="vertical">
        
            <button 
                nz-button 
                nzType="primary" 
                (click)="openModalAgents()"
                style="margin-bottom: 16px">
                + {{'agentBuilder.addsubagents'|translateTA}}
            </button>

            <div class="tab-container">
                <nz-table
                    nzBordered
                    [nzNoResult]="emptyTemplate"
                    [nzLoading]="loading"
                    [nzShowPagination]="true"
                    [(nzPageIndex)]="pageIndex"
                    [nzPageSize]="10"
                    [nzData]="subagents"
                    [nzScroll]="{ y: 'calc(100vh - 390px)' }"
                    #tableSubAgents
                    class="full-table">

                    <thead>
                        <tr>
                            <th nzWidth="80%">{{'agentBuilder.agent'|translateTA}}</th>
                            
                            <th nzWidth="20%">{{'agentBuilder.actions'|translateTA}}</th>
                        </tr>
                    </thead>

                    <tbody>
                        @for (group of tableSubAgents.data; track group.agentId?.key; let i = $index){
                            <tr>
                                <td>{{ group?.agentId.key }} - {{ group?.agentId?.value }}</td>                               
                                <td style="white-space: nowrap;">
                                    <button nz-button nzType="primary" nzSize="small" (click)="editSubAgent(i)" style="margin-right: 8px">
                                        {{'agentBuilder.edit'|translateTA}}
                                    </button>
                                    <button nz-button nzDanger nzSize="small" (click)="deleteSubAgent(i)">
                                        {{'agentBuilder.delete'|translateTA}}
                                    </button>
                                </td>
                            </tr>
                        }
                        
                    </tbody>
                </nz-table>
        
            </div>
    </form>
</div>

<nz-modal
  [(nzVisible)]="showModalAgents"
  [nzTitle]="editingIndexAgents>-1 ? ('agentBuilder.editsubagents'|translateTA) : ('agentBuilder.addsubagents'|translateTA)"
  nzOkText="{{'agentBuilder.save'|translateTA}}"
  nzCentered="true"
  nzCancelText="{{'agentBuilder.cancel'|translateTA}}"
  nzWidth="80vw"
  [nzStyle]="{ 'height': '90vh' }"
  [nzBodyStyle]="{ 'height': 'calc(90vh - 108px)', 'overflow': 'auto' }"
  (nzOnOk)="saveAgents()"
  (nzOnCancel)="closeAgentsModal()">
    <ng-container *nzModalContent>
        <form nz-form [formGroup]="formSubAgent" nzLabelAlign="right" nzLayout="vertical">
           
            <nz-form-item>
                <nz-form-label>{{'agentbuilder.agentid' | translateTA}}</nz-form-label>
                <nz-form-control>
                    <search-input-new [searchProperties]="searchAgentField" [variables]="variables" class="full-width" formControlName="agentId"
                    #searchInputIdhook
                    (onChangeData)="onChangeAgentId($event)"
                    ></search-input-new>
                </nz-form-control>
            </nz-form-item>
            
             <nz-form-item>
                <nz-form-label>{{'agentBuilder.rules'|translateTA}}</nz-form-label>
                <nz-form-control>
                    <div class="quill-container">
                        <quill-editor class="quill-container"  formControlName="rules" [format]="'html'" [styles]="{'min-height': (5 * 30) + 'px','width':'100%', 'height':'150px'}"></quill-editor>
                    </div>
                </nz-form-control>
            </nz-form-item>
           
            <!-- Quantas vezes este subagente pode ser acionado enquanto o agente
                 responde UMA pergunta. Evita que o agente principal fique chamando
                 o mesmo subagente em loop. -->
             <nz-form-item>
                <nz-form-label>{{'agentBuilder.maxIterators'|translateTA}}</nz-form-label>
                <nz-form-control [nzExtra]="'agentBuilder.maxIterators.hint'|translateTA">
                    <input nz-input type="number" formControlName="maxIterators" min="1"/>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<ng-template #emptyTemplate >
           <nz-empty 
              nzNotFoundContent="{{'agentBuilder.nosubagents'|translateTA}}"
              style="margin: 0">
            </nz-empty>
</ng-template>